import { onboardingAbandonmentDelayHoursSchema } from "@redotech/redo-onboarding-common/abandonment-notifications";
import * as z from "zod";

const onboardingAbandonmentNotificationsInput = z.object({
  delayHours: onboardingAbandonmentDelayHoursSchema,
  merchantReminderEmailEnabled: z.boolean(),
  slackNotificationEnabled: z.boolean(),
});

const onboardingAbandonmentNotificationsOutput =
  onboardingAbandonmentNotificationsInput.extend({
    slackChannelUrl: z.string().url(),
  });

export const getOnboardingAbandonmentNotifications = {
  name: "getOnboardingAbandonmentNotifications" as const,
  input: z.object({}),
  output: onboardingAbandonmentNotificationsOutput,
};

export const setOnboardingAbandonmentNotifications = {
  name: "setOnboardingAbandonmentNotifications" as const,
  input: onboardingAbandonmentNotificationsInput,
  output: onboardingAbandonmentNotificationsOutput,
};
